const mpUtil = require("./mpUtil")
const rm = require("./rm")

var blackIds = []
var blackNicks = []
function setBlackIds(ids) {
  blackIds = ids
}
function setBlackNicks(nicks) {
  blackNicks = nicks
}
function getAppShare() {
  return {
    title: 'IT之家 - 科技新闻头条速递，数码手机极客基地！',
    path: 'pages/index/index',
    imageUrl: 'http://img.ithome.com/weixin/share.jpg',
  }
}

/**
 * 是否在黑名单内
 */
function isBlackId(userId) {
  return blackIds.indexOf(userId + '') !== -1
}

/**
 * 是否在黑名单内
 */
function isBlackNick(nick) {
  return blackNicks.indexOf(nick) !== -1
}
const formatTime = (date) => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()
  return (
    [year, month, day].map(formatNumber).join('/') +
    ' ' +
    [hour, minute, second].map(formatNumber).join(':')
  )
}
const formatNumber = (n) => {
  n = n.toString()
  return n[1] ? n : '0' + n
}

/**
 * 从 2018-03-19T11:01:48.77 中解析出时间戳
 */

function getTimestamp(str) {
  var date = getDateFromString(str)
  return date.getTime()
}

function pad(num, n) {
  var len = `${num}`.length;
  while (len < n) {
    num = '0' + num;
    len++;
  }
  return num
}

/**
 * 从字符串中解析出时间戳
 */
function getDateFromString(str) {
  var dateStr = str
  if (isEmpty(str)) {
    return new Date()
  }
  if (dateStr.indexOf('/Date(') != -1) {
    dateStr = dateStr.replace('/Date(', '').replace(')/', '')
    dateStr = parseInt(dateStr)
  } else if (dateStr.indexOf('T') > 0) {
    // dateStr = dateStr.replace("T"," ").replace(/-/g, "/");
    if (dateStr.lastIndexOf('.') > 0) {
      dateStr = dateStr.substring(0, dateStr.lastIndexOf('.'))
    }
    // 没有时区
    if (dateStr.indexOf('+') == -1 && dateStr.indexOf('Z') == -1) {
      dateStr += '+08:00'
    }
  }
  return new Date(dateStr)
}

/**
 * 获取时间 xxxx-xx-xx xx:xx:xx，必要时自动省略年、日期
 */
function getFormatTimeForList(str) {
  var date = getDateFromString(str) //发布时间
  var now = new Date() //今天
  var yes = new Date(now.getTime() - 24 * 3600 * 1000) //昨天
  if (
    now.getFullYear() == date.getFullYear() &&
    now.getMonth() == date.getMonth() &&
    now.getDate() == date.getDate()
  ) {
    //今天
    return pad(date.getHours(), 2) + ':' + pad(date.getMinutes(), 2)
  } else if (
    yes.getFullYear() == date.getFullYear() &&
    yes.getMonth() == date.getMonth() &&
    yes.getDate() == date.getDate()
  ) {
    //昨天
    return '昨日 ' + pad(date.getHours(), 2) + ':' + pad(date.getMinutes(), 2)
  } else if (now.getFullYear() == date.getFullYear()) {
    //今年
    return pad(date.getMonth() + 1, 2) + '月' + pad(date.getDate(), 2) + '日' // + pad(date.getHours(), 2) + ":" + pad(date.getMinutes(), 2);
  } else {
    //往年
    return (
      pad(date.getFullYear(), 2) +
      '年' +
      pad(date.getMonth() + 1, 2) +
      '月' +
      pad(date.getDate(), 2) +
      '日'
    ) // + pad(date.getHours(), 2) + ":" + pad(date.getMinutes(), 2);
  }
}

/**
 * 获取时间 xxxx-xx-xx xx:xx:xx
 */
function getFormatTimeForCommentList(str) {
  var date = getDateFromString(str) //发布时间
  return (
    pad(date.getFullYear(), 2) +
    '-' +
    pad(date.getMonth() + 1, 2) +
    '-' +
    pad(date.getDate(), 2) +
    ' ' +
    pad(date.getHours(), 2) +
    ':' +
    pad(date.getMinutes(), 2)
  )
}
function getTimeArry(str = '', caculateDiff = false) {
  var date = getDateFromString(str) //发布时间
  var diffStr = ''
  if (caculateDiff) {
    var now = new Date().getTime()
    var then = date.getTime()
    var diff = now - then
    var min = 1000 * 60
    var hour = 1000 * 60 * 60
    var day = hour * 24
    var days = diff / day
    if (days < 365) {
      // 不到1年
      if (days < 1) {
        var hours = diff / hour
        if (hours < 1) {
          var mins = diff / min
          if (mins < 1) {
            diffStr = Math.ceil(mins * 60) + '秒前'
          } else {
            diffStr = Math.floor(mins) + '分钟前'
          }
        } else {
          diffStr = Math.floor(hours) + '小时前'
        }
      } else if (days < 7) {
        diffStr = Math.floor(days) + '天前'
      } else if (days < 14) {
        diffStr = '1周前'
      } else if (days < 21) {
        diffStr = '2周前'
      } else if (days < 30) {
        diffStr = '3周前'
      } else {
        diffStr = Math.floor(days / 30) + '月前'
      }
    } else {
      diffStr = Math.floor(days / 365) + '年前'
    }
  }
  return [
    pad(date.getFullYear(), 2),
    pad(date.getMonth() + 1, 2),
    pad(date.getDate(), 2),
    pad(date.getHours(), 2),
    pad(date.getMinutes(), 2),
    pad(date.getSeconds(), 2),
    diffStr,
  ]
}

/**
 * 获取日期 xxxx-xx-xx
 */
function getDateTime(str) {
  var date = new Date(str) //发布时间
  return (
    pad(date.getFullYear(), 2) +
    '-' +
    pad(date.getMonth() + 1, 2) +
    '-' +
    pad(date.getDate(), 2)
  )
}
function isEmpty(str) {
  return isUndefineOrEmpty(str)
}

// 字符串是否不为空
function isUndefineOrEmpty(str) {
  return str === undefined || str === '' || str === null
}


// 业务域名
var legalDomains = [
  'dyn.ithome.com',
  'www.ithome.com',
  'my.ruanmei.com',
  'wap.ithome.com',
  'm.lapin365.com',
  'www.lapin365.com',
  'live.ithome.com',
  'm.ithome.com',
  'mapi.lapin365.com',
  'www.ruanmei.com',
]
var ruanmeiDomains = [
  'ithome.com',
  'ruanmei.com',
  'lapin365.com',
  'vista123.com',
  'win8china.com',
  'win7china.com',
]
const decodeUrlParams = (value) => {
  try {
    return decodeURIComponent(value);
  } catch (error) {
    return value;
  }
};
// 可识别为链接的域名

/**
 * 从url中取出域名，hostname
 */
function getDomainFormUrl(url) {
  var domain = url.split('/')
  if (domain.length >= 2 && domain[2]) {
    domain = domain[2]
  } else {
    domain = ''
  }
  if (domain.indexOf('?') > 0) {
    domain = domain.split('?')[0]
  }
  return domain
}
function parasUrl(url) {

  let tempUrl = url;

  const parts = url.split('://');
  const scheme = parts[1] ? parts[0] : '';
  let domain = parts[1] || parts[0];
  let path = '';
  if (domain.indexOf('?') !== -1) {
    domain = domain.substring(0, domain.indexOf('?'));
  }
  if (domain.indexOf('#') !== -1) {
    domain = domain.substring(0, domain.indexOf('#'));
  }

  if (domain.indexOf('/') !== -1) {
    // eslint-disable-next-line prefer-destructuring
    path = domain.substring(domain.indexOf('/'));
    // eslint-disable-next-line prefer-destructuring
    domain = domain.split('/')[0];
  }
  const params = {};
  let key = '';
  let value = '';

  // 金山云图片水印、裁剪等参数
  const tagList = [];
  // http://img.ithome.com/newsuploadfiles/2021/1/20210131221301_6513.jpg@base@tag=imgWaterMark&type=1&dissolve=50&gravity=SouthEast&image=aHR0cDovL2ltZy5pdGhvbWUuY29tL2ltZy9xdy5wbmc=&dy=50&dx=10%7Ctag=imgScale&p=100&r=2&rotate=0
  if (url.indexOf('@base@') !== -1) {
    tempUrl = url.substring(0, url.indexOf('@base@'));
    const tagStr = url.substring(url.indexOf('@base@') + 6);
    const tags = tagStr.split(/\||%7C/);
    tags.forEach((tag) => {
      const pairStr = tag.split('&');
      const tagInfo = {};
      pairStr.forEach((pair) => {
        if (pair.indexOf('=') > 0) {
          key = pair.substring(0, pair.indexOf('='));
          value = pair.substring(pair.indexOf('=') + 1);
          tagInfo[key] = decodeUrlParams(value);
        }
      });
      tagList.push(tagInfo);
    });
  }
  const bdTagList = [];
  // https://doc.bce.baidu.com/bce-documentation/BOS/image.jpg?x-bce-process=image/watermark,image_YmNlLWRvY3VtZW50YXRpb24vQk9TL2JjZS5qcGc=,g_9,a_90/resize,m_lfit,w_200,h_100
  if (url.indexOf('x-bce-process=image') !== -1) {
    tempUrl = url.substring(0, url.indexOf('x-bce-process=image') - 1);
    const tagStr = url.substring(
      url.indexOf('x-bce-process=image/') + 'x-bce-process=image/'.length,
    );
    const tags = tagStr.split(/\//);
    tags.forEach((tag) => {
      const pairStr = tag.split(',');
      const tagInfo = {};
      pairStr.forEach((pair, index) => {
        if (index === 0) {
          tagInfo['action'] = pair;
        } else if (pair.indexOf('_') > 0) {
          key = pair.substring(0, pair.indexOf('_'));
          value = decodeUrlParams(pair.substring(pair.indexOf('_') + 1));
          tagInfo[key] = isNumber(value) ? Number(value) : value;
        }
      });
      bdTagList.push(tagInfo);
    });
  }
  const paraString = tempUrl.substring(tempUrl.indexOf('?') + 1, tempUrl.length).split('&');
  // eslint-disable-next-line no-restricted-syntax
  // eslint-disable-next-line @typescript-eslint/no-for-in-array
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < paraString.length; i++) {
    const str = paraString[i];
    if (str.indexOf('=') > 0) {
      key = str.substring(0, str.indexOf('='));
      value = str.substring(str.indexOf('=') + 1);
      if (value.indexOf('#') !== -1) {
        value = value.substring(0, value.indexOf('#'));
      }
      value = decodeUrlParams(value);
      if (isNumber(value)) {
        value = Number(value);
      }
      params[key] = value;
    }
  }

  let pureUrl = url;
  if (pureUrl.indexOf('?') !== -1) {
    pureUrl = pureUrl.substring(0, pureUrl.indexOf('?'));
  }
  if (pureUrl.indexOf('#') !== -1) {
    pureUrl = pureUrl.substring(0, pureUrl.indexOf('#'));
  }
  if (pureUrl.indexOf('@') !== -1) {
    pureUrl = pureUrl.substring(0, url.indexOf('@'));
  }
  let ext = '';
  if (path.lastIndexOf('.') !== -1 && !path.endsWith('.')) {
    ext = path.substr(path.lastIndexOf('.') + 1).toLowerCase();
  }
  let port;
  if (domain.indexOf(':') !== -1) {
    port = domain.substring(domain.indexOf(':') + 1);
    domain = domain.substring(0, domain.indexOf(':'));
  }
  let topDomain = domain.replace('.com.cn', '.comdotcn');
  while (topDomain.indexOf('.') !== topDomain.lastIndexOf('.')) {
    topDomain = topDomain.substring(topDomain.indexOf('.') + 1);
  }
  topDomain = topDomain.replace('.comdotcn', '.com.cn');
  return {
    scheme: scheme.toLowerCase(),
    host: domain.toLowerCase(),
    port,
    path,
    topDomain,
    params,
    tagList,
    bdTagList,
    ext,
    hash: url.indexOf('#') !== -1 ? url.substring(url.indexOf('#') + 1) : '',
    pureUrl,
  };
}
function isRuanmeiUrl(url) {
  var domain = getDomainFormUrl(url)
  var topDomain = domain
  // 只留一个.
  while (
    topDomain.indexOf('.') > 0 &&
    topDomain.indexOf('.') !== topDomain.lastIndexOf('.')
  ) {
    topDomain = topDomain.substring(topDomain.indexOf('.') + 1)
  }
  return ruanmeiDomains.indexOf(topDomain) !== -1
}


function processLainListLitm(app, list, customToApp = undefined) {
  list.forEach((item) => {
    // 列表显示时间
    item.timeForList = getFormatTimeForList(item.LastModifyTime)

    // 最终点击跳转目标
    var clickJumpUrl = item.QuanUrl
    if (isEmpty(clickJumpUrl)) {
      clickJumpUrl = item.BuyUrl
    }
    var toApp = !app.globalData.uiSettings.WeappShowDetail
    if (typeof customToApp != typeof undefined) {
      toApp = customToApp
    }
    if (item.productid < 0) {
      toApp = true
    }
    item.clickJumpUrl = mpUtil.parse(
      clickJumpUrl,
      toApp ? getLapinItemLinkAttr(item) : {}
    )

    // 显示商城小图标
    if (!isEmpty(item.OriginStoreImage)) {
      item.showOriginStoreIcon = true
    } else if (
      !isEmpty(item.OriginStoreName) &&
      !isEmpty(item.OriginStoreColor)
    ) {
      item.showOriginStoreTextIcon = true
    }

    // 促销信息
    if (item.PromotionList != null && item.PromotionList.length > 0) {
      item.showPromotionString = true
      item.PromotionString = item.PromotionList.join(' ')
    } else {
      item.showPromotionString = false
    }
  })
}
function getLapinItemLinkAttr(item) {
  var attr = {}
  if (item.malltoken == 'pinduoduo') {
    attr.data_linktoken = 'pinduoduo'
  } else if (item.malltoken == 'jd') {
    attr.data_jdid = item.OriginalProductId
  }
  return attr
}


/**
 * 本地评论打分历史
 */
var voteHistory = null
function saveVoteList(data) {
  voteHistory = data
}


/**
 * 对评论内容进行处理
 */
function processCommentContent(content, replyToUserId) {
  var contentArray = []
  try {
    var contentLeft = content
    var indexOfReplyPre = content.indexOf('回复')
    var indexOfSharp = content.indexOf('#')
    var indexOfComm = content.indexOf('：')

    // 被回复xxx可点击
    if (
      replyToUserId > 0 &&
      indexOfReplyPre === 0 &&
      indexOfSharp > 0 &&
      indexOfComm > indexOfSharp &&
      indexOfComm + 1 < content.length
    ) {
      var lou = contentLeft.substring(2, indexOfSharp).trim()
      var replyNick = contentLeft
        .substring(indexOfSharp + 1, indexOfComm)
        .trim()
      contentArray.push({
        content: '回复' + lou + '# ',
      })
      contentArray.push({
        content: replyNick,
        className: 'comment-reply-to',
        link: '/pages/userPage/userPage?userid=' + replyToUserId,
      })
      contentArray.push({
        content: '：',
      })
      contentLeft = contentLeft.substring(indexOfComm + 1)
    }

    // 搜索链接
    // /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/g;
    // /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
    // /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})/;
    var regEx =
      /(http|https|ithome):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))?([\w.,@?^=%&:\/~+#-]*[\w@?^=%&\/~+#-])?/g
    var links = contentLeft.match(regEx)
    if (links && links.length > 0) {
      // 匹配到链接
      var lastEndIndex = 0
      for (var j = 0; j < links.length; j++) {
        var url = links[j]
        //对链接的截断做特殊处理
        if (url.indexOf('.html') !== -1 && !url.endsWith('.html')) {
          url = url.substring(0, url.indexOf('.html') + 5)
        } else if (url.indexOf('.htm') !== -1 && !url.endsWith('.htm')) {
          url = url.substring(0, url.indexOf('.htm') + 4)
        } else {
          //遍历，如果有非ASCII字符，则截断
          for (var i = 0; i < url.length; i++) {
            if (url[i].charCodeAt(0) > 127) {
              url = url.substring(0, i)
            }
          }
        }
        if (isRuanmeiUrl(url)) {
          var startIndex = contentLeft.indexOf(url)
          var endIndex = startIndex + url.length
          contentArray.push({
            content: contentLeft.substring(lastEndIndex, startIndex),
          })
          contentArray.push({
            content: url,
            className: 'comment-content-url',
            link: url,
          })
          lastEndIndex = endIndex
        }
      }
      if (lastEndIndex <= contentLeft.length - 1) {
        contentArray.push({
          content: contentLeft.substring(lastEndIndex),
        })
      }
    } else {
      contentArray.push({
        content: contentLeft,
      })
    }
  } catch (e) {
    contentArray = []
    contentArray.push({
      content: content,
    })
  }
  return contentArray
}

/**
 * 评论列表数据扁平化，去掉嵌套
 */
function flatList(commentList) {
  var flatResultList = []
  commentList.forEach(function (val, index, arr) {
    var childList = val.childList
    var main = val
    //主楼
    main.againstAction = main.myVoteValue < 0 ? 'cancelAgainst' : 'against'
    main.againstActionText = main.myVoteValue < 0 ? '取消' : '反对'
    main.supportAction = main.myVoteValue > 0 ? 'cancelSupport' : 'support'
    main.supportActionText = main.myVoteValue > 0 ? '取消' : '支持'
    main.additionalClass = ''
    flatResultList.push(main)
    //子楼
    childList.forEach(function (item, childIndex, arra) {
      var item = childList[childIndex]
      item.additionalClass = 'comment-container-child'
      item.isChild = true
      if (childIndex == 0) {
        item.isFirstChild = true
        item.additionalClass += ' comment-container-child-first'
      }
      if (childIndex == childList.length - 1) {
        item.isLastChild = true
        item.additionalClass += ' comment-container-child-last'
      }
      item.againstAction = item.myVoteValue < 0 ? 'cancelAgainst' : 'against'
      item.againstActionText = item.myVoteValue < 0 ? '取消' : '反对'
      item.supportAction = item.myVoteValue > 0 ? 'cancelSupport' : 'support'
      item.supportActionText = item.myVoteValue > 0 ? '取消' : '支持'
      flatResultList.push(item)
    })
  })
  return flatResultList
}

function getRMVipIconUrl(rmCode, isRm = false) {
  var icon = isRm ? '/images/tail_small_rm.png' : false
  if (typeof rmCode == typeof undefined) {
    return icon
  }
  rmCode = rmCode + ''
  if (rmCode === '1') {
    icon = '/images/tail_small_dev.png'
  } else if (rmCode == '2') {
    icon = '/images/tail_small_editor.png'
  } else if (rmCode == '9') {
    icon = '/images/tail_small_rm.png'
  }
  return icon
}
function getRMVipType(rmCode, isRm = false) {
  var type = isRm ? 'normal' : false
  if (typeof rmCode == typeof undefined) {
    return type
  }
  rmCode = rmCode + ''
  if (rmCode === '1') {
    type = 'coder'
  } else if (rmCode == '2') {
    type = 'editor'
  } else if (rmCode == '9') {
    type = 'normal'
  }
  return type
}

function isNumber(value) {
  if (typeof value === 'object' || isUndefineOrEmpty(value)) {
    return false
  } else {
    return !Number.isNaN(Number(value))
  }
}
function processSliderListItem(list, checkTime = false) {
  var result = []
  list.forEach(function (val, index, arr) {
    var link = val.link
    if (isNumber(link)) {
      link = '/detail?isrmmp=1&hidemenu=1&internal=1&id=' + link
    }
    var item = {
      image: val.image,
      link: link,
      opentype: val.opentype,
      starttime: val.starttime,
      endtime: val.endtime,
      device: val.device,
    }
    result.push(item)
  })

  //检查起止时间
  if (checkTime) {
    result = result.filter((item) => {
      var startTime = getTimestamp(item.starttime)
      var nowTime = new Date().getTime()
      var endTime = getTimestamp(item.endtime)
      return nowTime >= startTime && nowTime <= endTime
    })
  }
  return result
}
function getTailType(cl, ta) {
  var code = parseInt(cl)
  var ta1 = isUndefineOrEmpty(ta) ? '' : ta
  var tc
  if (isUndefineOrEmpty(ta1) && code == 29) {
    ta1 = 'IT之家小程序'
  }
  if (!isUndefineOrEmpty(ta1) && code != 0) {
    // 1 WP 3 iPhone 4 iPad 5 iTouch 6 WAP 8 Android 7|9|10 windows8/10
    switch (code) {
      case 1:
        tc = 'wp'
        break
      case 3:
        tc = 'iphone'
        break
      case 4:
        tc = 'ipad'
        break
      case 5:
        tc = 'itouch'
        break
      case 6:
        tc = 'wap'
        break
      case 8:
        tc = 'android'
        break
      case 7:
      case 9:
      case 10:
        tc = 'windows8'
        break
      case 11:
        tc = 'win10'
        break
      case 13:
        tc = 'watch'
        break
      case 14:
        tc = 'imac'
        break
      case 15:
        tc = 'macbook'
        break
      case 16:
        tc = 'iphonex'
        break
      case 17:
        tc = 'xbox'
        break
      case 18:
        tc = 'androidCar'
        break
      case 19:
        tc = 'sf'
        break
      case 12:
      case 21:
        tc = 'qiyu'
        break
      case 25:
        tc = 'androidTv'
        break
      case 26:
        tc = 'androidWatch'
        break
      case 27:
        tc = 'blackberry'
        break
      case 28:
        tc = 'hololens'
        break
      case 29:
        tc = 'weixin'
        break
      default:
        tc = ''
        break
    }
  } else {
    switch (code) {
      case 12:
        ta1 = '旗鱼浏览器WP版'
        tc = 'qiyu'
        break
      case 21:
        ta1 = '旗鱼浏览器'
        tc = 'qiyu'
        break
      case 22:
        ta1 = '旗鱼浏览器安卓版'
        tc = 'qiyu'
        break
      case 23:
        ta1 = '旗鱼浏览器iOS版'
        tc = 'qiyu'
        break
      default:
        tc = ''
        break
    }
  }
  return [tc, ta1]
}

/**
 * 本地帖子打分历史
 */
var postVoteHistory = null
function savePostVoteList(data) {
  postVoteHistory = data
}

function getAvatarAddress(userID, useLargeAvatar) {
  var strUserID = userID + ''
  while (strUserID.length < 9) {
    strUserID = '0' + strUserID
  }
  var dir1 = strUserID.substring(0, 3)
  var dir2 = strUserID.substring(3, 5)
  var dir3 = strUserID.substring(5, 7)
  var dir4 = strUserID.substring(7, 9)
  if (useLargeAvatar) {
    return (
      'https://my.ruanmei.com/images/upload/avatars/' +
      dir1 +
      '/' +
      dir2 +
      '/' +
      dir3 +
      '/' +
      dir4 +
      '_avatar.jpg'
    )
  }
  return (
    'http://avatar.ithome.com/avatars/' +
    dir1 +
    '/' +
    dir2 +
    '/' +
    dir3 +
    '/' +
    dir4 +
    '_60.jpg'
  )
}

/**
 * 对商品列表字段进行处理
 */
function toListData(content) {
  var list = []
  content.forEach(function (val, index, arr) {
    var thumbnail =
      val.Picture.indexOf('/') == 0
        ? 'https://img.lapin365.com' + val.Picture
        : val.Picture
    var buttonClass =
      val.QuanUrl != undefined && val.QuanUrl != ''
        ? 'list-item-button-coupon'
        : 'list-item-button-buy'
    var now = new Date()
    var pubtime = getFormatTimeForList(val.LastModifyTime)
    var httpLink = !isUndefineOrEmpty(val.QuanUrl) ? val.QuanUrl : val.BuyUrl
    if (isUndefineOrEmpty(httpLink)) httpLink = val.Link
    var navLink =
      val.productid > 0
        ? '../detail/detail?productid=' + val.productid
        : httpLink
    var item = {
      id: val.productid,
      title: val.ProductName,
      thumbnail: thumbnail,
      shopname: val.OriginStoreName,
      shopbgcolor: val.OriginStoreColor,
      buttonClass: buttonClass,
      buttonText: val.QuanInfo,
      promotionInfo: val.PromotionInfoPrice,
      priceInfo: val.RealPrice,
      pubtime: pubtime,
      sales: val.SalesVolumeStr,
      showShopIcon: !isUndefineOrEmpty(val.OriginStoreImage),
      shopIcon: val.OriginStoreImage,
      comment: !isUndefineOrEmpty(val.CommentStr)
        ? '　　' + val.CommentStr
        : '',
      promotionList: val.PromotionList,
      navLink: navLink,
    }
    list.push(item)
  })
  return list
}
var deviceCode = "";
// if(rm.isLegalEnv()){
//   deviceCode = rm.getSystemInfoSync().systemInfo.model + ' ' + rm.getSystemInfoSync().systemInfo.brand;
// }

function getDeviceCode() {
  if (typeof deviceCode == typeof undefined || deviceCode.length == 0) {
    return 'unknown'
  }
  // 针对苹果机型做处理，原始： "iPhone SE<iPhone8,4> iPhone";
  if (
    deviceCode.indexOf('<') != -1 &&
    deviceCode.indexOf('>') > deviceCode.indexOf('<')
  ) {
    deviceCode = deviceCode.substring(
      deviceCode.indexOf('<') + 1,
      deviceCode.indexOf('>')
    )
  }
  deviceCode = deviceCode.replace('<', '').replace('>', '')
  return deviceCode
}
function isAppleDevice() {
  if (typeof deviceCode == typeof undefined || deviceCode.length == 0) {
    return false
  }
  var device = deviceCode.toLowerCase()
  return (
    device.indexOf('iphone') != -1 ||
    device.indexOf('ipod') != -1 ||
    device.indexOf('ipad') != -1
  )
}
function px2Rpx(app, value) {
  return (750 * value) / app.globalData.windowWidth
}
function rpx2Px(app, value) {
  return (app.globalData.windowWidth * value) / 750
}

function strToHexCharCode(str) {
  if (str === '') return ''
  var hexCharCode = []
  for (var i = 0; i < str.length; i++) {
    hexCharCode.push('%' + str.charCodeAt(i).toString(16))
  }
  return hexCharCode.join('')
}
function getRandomString(length) {
  var base = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  var result = ''
  for (var i = 0; i < length; i++) {
    var index = Math.floor(Math.random() * base.length)
    if (index >= length) index = length - 1
    result += base[index]
  }
  return result
}
function getLeftTimeStr(startTime, betweenMin) {
  var leftTime = getLeftTimeHHMMArray(startTime, betweenMin)
  var hour = leftTime[0]
  var min = leftTime[1]
  if (hour <= 0 && min <= 0) {
    return '交易关闭'
  }
  return (
    '支付剩余' + (hour > 0 ? hour + '时' : '') + (min > 0 ? min + '分' : '')
  )
}
function getLeftTimeHHMMArray(startTime, betweenMin) {
  var creatTimestamp = getTimestamp(startTime)
  var autoCloseTimestamp = creatTimestamp + betweenMin * 60 * 1000
  var nowTimestamp = new Date().getTime()
  var leftMinute = Math.ceil((autoCloseTimestamp - nowTimestamp) / (60 * 1000))
  var hour = Math.floor(leftMinute / 60)
  var min = leftMinute % 60
  return [hour, min]
}
function getStartTimeLeftArray(startTime, diff = 0) {
  var startTimestamp = getTimestamp(startTime) + diff;
  var nowTimestamp = new Date().getTime()
  var lefttime = parseInt((startTimestamp - nowTimestamp) / 1000),
    d = Math.floor(lefttime / (60 * 60 * 24)),
    h = Math.floor((lefttime / (60 * 60)) % 24),
    m = Math.floor((lefttime / 60) % 60),
    s = Math.floor(lefttime % 60)
  return [d, pad(h, 2), pad(m, 2), pad(s, 2), nowTimestamp >= startTimestamp]
}
function round(num, lengthAfterPoint) {
  var temp = Math.pow(10, lengthAfterPoint)
  return Math.round(num * temp) / temp
}
function processPriceStr(priceStr) {
  var strs = priceStr.split('¥')
  var result = []
  if (strs[0].length > 0) {
    result.push({
      isIcon: false,
      text: strs[0],
    })
  }
  if (strs.length > 1) {
    for (var i = 1; i < strs.length; i++) {
      result.push({
        isIcon: true,
        text: '¥',
      })
      if (strs[i].length > 0) {
        result.push({
          isIcon: true,
          text: strs[i],
        })
      }
    }
  }
}

// 不允许短时间内重复点击按钮
var lastTime = 0
function allowClick() {
  var now = new Date().getTime()
  if (now - lastTime < 400) {
    lastTime = now
    return false
  }
  lastTime = now
  return true
}

function navigateTo(url) {
  (window["rm"]).navigateTo({
    url: url
  })
}

module.exports = {
  formatTime: formatTime,
  getTimestamp: getTimestamp,
  isUndefineOrEmpty: isUndefineOrEmpty,
  toListData: toListData,
  getAvatarAddress: getAvatarAddress,
  getDateTime: getDateTime,
  pad: pad,
  saveVoteList: saveVoteList,
  processSliderListItem: processSliderListItem,
  getFormatTimeForCommentList: getFormatTimeForCommentList,
  flatList: flatList,
  rpx2Px: rpx2Px,
  px2Rpx: px2Rpx,
  isAppleDevice: isAppleDevice,
  strToHexCharCode: strToHexCharCode,
  isNumber: isNumber,
  savePostVoteList: savePostVoteList,
  getTimeArry: getTimeArry,
  isEmpty: isEmpty,
  setBlackIds: setBlackIds,
  setBlackNicks: setBlackNicks,
  isBlackId: isBlackId,
  isBlackNick: isBlackNick,
  getRandomString: getRandomString,
  getLeftTimeStr: getLeftTimeStr,
  round: round,
  getLeftTimeHHMMArray: getLeftTimeHHMMArray,
  processPriceStr: processPriceStr,
  parasUrl: parasUrl,
  isRuanmeiUrl: isRuanmeiUrl,
  getAppShare: getAppShare,
  allowClick: allowClick,
  getStartTimeLeftArray: getStartTimeLeftArray,
  processLainListLitm: processLainListLitm,
  getLapinItemLinkAttr: getLapinItemLinkAttr,
  navigateTo: navigateTo
}
